import React, { useState, handlelick, active, useContext } from "react";
import "./Sidebar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import Accordion from "react-bootstrap/Accordion";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas, faWallet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { Context } from "../../utils/context";
import { faAffiliatetheme } from "@fortawesome/free-brands-svg-icons";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";

library.add(fas);

const Sidebar = () => {
  const { isSidebarOpen, setSidebarOpen, isAllow } = useContext(Context);
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(true);
  const [showItemNames, setShowItemNames] = useState(true);
  const [headerText, setHeaderText] = useState(location.pathname);

  useEffect(() => {
    setHeaderText(location.pathname);
  });

  const [active, setActive] = useState("0");
  const handleClick = (eventKey) => {
    if (active === eventKey) {
      setActive(null);
    } else {
      setActive(eventKey);
      // setSidebarOpen(true);
    }
  };

  const isActive = (path) => {
    return location.pathname.includes(path) ? "active block" : "none";
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();

  return (
    <>
      <section className="sidebar">
        <div className="desktop-view-sidebar">
          <div className="top_section">
            <img
              className="logo "
              src={process.env.PUBLIC_URL + "/logo_sangli.png"}
              onClick={() => navigate("/advanceDashboard")}
              // src={process.env.PUBLIC_URL + "/netpurtilogo.png"}
              // src={process.env.PUBLIC_URL + "/Mansa_Nutri_Logo.png"}
            />
            {/* <h3>Flick And Shoot</h3>/ */}
            {/* <h1>Net Purti</h1> */}
          </div>

          <ul className="list-unstyled ps-0">
            {/* ***************************************************Dashboard*************************************************************** */}

            <Accordion
              // defaultActiveKey="0"
              className=""
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded="false">
              <Accordion.Item
                eventKey="0"
                className=""
                onClick={() => handleClick("0")}>
                <Accordion.Header>
                  <div className="Accordion_Header_icon-holder">
                    <FontAwesomeIcon
                      icon="fa-solid fa-house"
                      onClick={() => setIsOpen(!isOpen)}
                    />
                  </div>
                  <p
                    className="sidebar_txt"
                    style={{ display: isSidebarOpen ? "block" : "none" }}
                    onClick={() => setSidebarOpen(true)}>
                    Dashboard
                  </p>

                  {/* </button> */}
                </Accordion.Header>
                <Accordion.Body className="p-0">
                  <ul
                    className={`accordion_list list-unstyled fw-normal pb-1 small ${
                      isSidebarOpen ? "arrowshow" : "arrowHide"
                    }`}
                    style={{
                      display: isSidebarOpen ? "block" : "none",
                    }}>
                    <Link
                      to="/advanceDashboard"
                      className="text-decoration-none">
                      <li className={isActive("/advanceDashboard")}>
                        <p key={2} className="insideDropdown_list" id={"2"}>
                          Advance Dashboard
                        </p>
                      </li>
                    </Link>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              {isAllow?.includes(144) || isAllow?.includes(149) ? (
                <Accordion.Item
                  eventKey="43"
                  className=""
                  onClick={() => handleClick("43")}>
                  <Accordion.Header>
                    <div className="Accordion_Header_icon-holder">
                      <FontAwesomeIcon
                        icon="fa-solid fa-taxi"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Cabs
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(149) ? (
                        <Link
                          to="/settings/cab-type"
                          className=" text-decoration-none "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/cab-type")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Cab Type
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(144) ? (
                        <Link
                          to="/settings/cab-fare"
                          className=" text-decoration-none"
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/cab-fare")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Cab Fare
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* <Link
                      to="/settings/cabs"
                      className=" text-decoration-none  "
                    // className="text-decoration-none rounded "
                    >
                      <li
                        className={
                          isOpen
                            ? headerText.includes("/settings/cabs")
                              ? "active block"
                              : "none"
                            : "none"
                        }
                      >
                        <p
                          className="insideDropdown_list"
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Cabs
                        </p>
                      </li>
                    </Link> */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {isAllow?.includes(29) || isAllow?.includes(33) ? (
                <Accordion.Item
                  eventKey="2"
                  className=""
                  onClick={() => handleClick("2")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon icon="fa-solid fa-list" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Categories
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul className="accordion_list list-unstyled fw-normal pb-1 small">
                      {isAllow?.includes(29) ? (
                        <Link
                          to="/settings/category"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(33) ? (
                        <Link
                          to="/settings/sub-category"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/sub-category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Sub Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {isAllow?.includes(136) || isAllow?.includes(132) ? (
                <Accordion.Item
                  eventKey="88"
                  className=""
                  onClick={() => handleClick("88")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon
                        icon="fa-solid fa-square-check"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Booking
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(132) ? (
                        <Link
                          to="/bookings"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/bookings")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Booking
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(132) ? (
                        <Link
                          to="/app-bookings"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/app-bookings")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              App Booking
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                      {isAllow?.includes(136) ? (
                        <Link
                          to="/booking-cancelled"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/booking-cancelled")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Booking Cancel
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(136) ? (
                        <Link
                          to="/booking-rejected"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/booking-rejected")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Booking Rejected
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {isAllow?.includes(153) ? (
                <Accordion.Item
                  eventKey="45"
                  className=""
                  onClick={() => handleClick("45")}>
                  <Accordion.Header>
                    <div className="Accordion_Header_icon-holder">
                      <FontAwesomeIcon
                        icon="fa-solid fa-taxi"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Coupons
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(153) ? (
                        <Link
                          to="/settings/Coupon-codes"
                          className=" text-decoration-none "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/Coupon-codes")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Coupons
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {isAllow?.includes(99) || isAllow?.includes(103) ? (
                <Accordion.Item
                  eventKey="41"
                  className=""
                  onClick={() => handleClick("41")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon
                        icon="fa-solid fa-list-ol"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Packages
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(99) ? (
                        <Link
                          to="/packages"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/packages")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Packages
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(103) ? (
                        <Link
                          to="/local-packages"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/local-packages")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Local Packages
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}{" "}
              {isAllow?.includes(158) || isAllow?.includes(163) ? (
                <Accordion.Item
                  eventKey="87"
                  className=""
                  onClick={() => handleClick("87")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon icon="fa-solid fa-location-dot" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Routes
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(158) ? (
                        <Link
                          to="/category-route"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/category-route")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Route Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(163) ? (
                        <Link
                          to="/sub-category-route"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/sub-category-route")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Route SubCategory
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************   Content Start ************************************************************* */}
              {isAllow?.includes(45) ? (
                <Accordion.Item
                  eventKey="20"
                  className=""
                  onClick={() => handleClick("20")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon icon="fa-solid fa-circle-question" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      FAQs
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(45) ? (
                        <Link
                          to="/settings/customization/faqs"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/faqs",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              FAQ
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************  Settings End ************************************************************* */}
              {/* ************************************************************   subscription Start ************************************************************* */}
              {/* {isAllow?.includes(168) || isAllow?.includes(172) ? (
                <Accordion.Item
                  eventKey="26"
                  className=""
                  onClick={() => handleClick("26")}
                >
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
"
                    >
                      <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Subscription Management
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(168) ? (
                        <Link
                          to="/settings/customization/subscriptions"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/subscriptions"
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Subscription
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(172) ? (
                        <Link
                          to="/settings/customization/subscription_history"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/subscription_history"
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Subscription History
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}
              {/* ************************************************************  subscription End ************************************************************* */}
              {/* ************************************************************   MASTERS Start ************************************************************* */}
              {isAllow?.includes(226) ||
              isAllow?.includes(181) ||
              isAllow?.includes(177) ||
              isAllow?.includes(173) ? (
                <Accordion.Item
                  eventKey="22"
                  className=""
                  onClick={() => handleClick("22")}>
                  <Accordion.Header>
                    <div className="Accordion_Header_icon-holder">
                      <FontAwesomeIcon
                        icon="fa-solid fa-gear"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Masters
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {/* <Link
                      to="/settings/customization/contact-support"
                      className=" text-decoration-none  "
                    // className="text-decoration-none rounded "
                    >
                      <li
                        className={
                          isOpen
                            ? headerText.includes(
                              "/settings/customization/contact-support"
                            )
                              ? "active block"
                              : "none"
                            : "none"
                        }
                      >
                        <p
                          className="insideDropdown_list"
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Contact Support
                        </p>
                      </li>
                    </Link> */}

                      {isAllow?.includes(173) ? (
                        <Link
                          to="/settings/customization/fuel-type"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/fuel-type",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Fuel Type
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(177) ? (
                        <Link
                          to="/settings/customization/seat-capacity"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/seat-capacity",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Seat Capacity
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(181) ? (
                        <Link
                          to="/master/reasons-cancellation"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/master/reasons-cancellation",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Reasons Cancellation
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(226) ? (
                        <Link
                          to="/master/cancellation-charges"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/master/cancellation-charges",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Cancellation Charges
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************  MASTERS End ************************************************************* */}
              {/* ************************************************************   DRIVER Start ************************************************************* */}
              {/* {isAllow?.includes(201) ? (
                <Accordion.Item
                  eventKey="28"
                  className=""
                  onClick={() => handleClick("28")}
                >
                  <Accordion.Header>
                    <div className="Accordion_Header_icon-holder">
                      <FontAwesomeIcon icon="fa-solid fa-circle-user" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}
                    >
                      Drivers
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(201) ? (
                        <Link
                          to="/settings/customization/driver"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/driver"
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }
                          >
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}
                            >
                              Driver Data
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                     
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}
              {/* ************************************************************  DRIVER End ************************************************************* */}
              {/* ************************************************************  Categories ************************************************************* */}
              {/* {isAllow?.includes(191) || isAllow?.includes(196) ? (
                <Accordion.Item
                  eventKey="42"
                  className=""
                  onClick={() => handleClick("42")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon icon="fa-solid fa-blog" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Blog
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(191) ? (
                        <Link
                          to="/settings/blog-category"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/blog-category")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Blog Category
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(196) ? (
                        <Link
                          to="/settings/blogs"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/blogs")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Blog
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}
              {/* ************************************************************  Categories End ************************************************************* */}
              {/* ************************************************************  Home Settings  ************************************************************* */}
              {isAllow?.includes(206) ||
              isAllow?.includes(210) ||
              isAllow?.includes(214) ? (
                <Accordion.Item
                  eventKey="9"
                  className=""
                  onClick={() => handleClick("9")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon
                        icon="fa-solid fa-house-laptop"

                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Home Settings
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {/* {isAllow?.includes(206) ? (
                        <Link
                          to="/home/happy-customer"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/home/happy-customer")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Happy Customer
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {isAllow?.includes(210) ? (
                        <Link
                          to="/home/why-ride"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/home/why-ride")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Why Ride
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(214) ? (
                        <Link
                          to="/home/key-services"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/home/key-services")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Key Services
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(206) ? (
                        <Link
                          to="/car-available"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/car-available")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Car Available
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(206) ? (
                        <Link
                          to="/gallery"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/gallery")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              gallery
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {isAllow?.includes(114) ||
              isAllow?.includes(122) ||
              isAllow?.includes(123) ||
              isAllow?.includes(130) ? (
                <Accordion.Item
                  eventKey="18"
                  className=""
                  onClick={() => handleClick("18")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon
                        icon="fa fa-users"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Customers
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul className="accordion_list list-unstyled fw-normal pb-1 small">
                      {isAllow?.includes(114) ? (
                        <Link
                          to="/employee/contact-us"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/employee/contact-us")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Contact Us
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(114) ? (
                        <Link
                          to="/journey-inquiry"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/journey-inquiry")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Journey Inquiry
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(130) ? (
                        <Link
                          to="/employee/customer-details"
                          className="text-decoration-none">
                          <li
                            className={isActive("/employee/customer-details")}>
                            <p key={2} className="insideDropdown_list" id={"2"}>
                              Customer Details
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}

                      {/* {isAllow?.includes(122) ? (
                        <Link
                          to="/employee/fraud-user"
                          className="text-decoration-none"
                        >
                          <li className={isActive("/employee/fraud-user")}>
                            <p key={2} className="insideDropdown_list" id={"2"}>
                              Fraud User
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                      {isAllow?.includes(123) ? (
                        <Link
                          to="/employee/package-book"
                          className="text-decoration-none">
                          <li className={isActive("/employee/package-book")}>
                            <p key={2} className="insideDropdown_list" id={"2"}>
                              Package Book Request
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************  Customers End ************************************************************* */}
              {/* ************************************************************  Customization ************************************************************* */}
              {isAllow?.includes(73) ? (
                <Accordion.Item
                  eventKey="5"
                  className=""
                  onClick={() => handleClick("5")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon
                        icon="fa-solid fa-sliders"
                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      App SetUp
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul className="accordion_list list-unstyled fw-normal pb-1 small">
                      {isAllow?.includes(73) ? (
                        <Link
                          to="/settings/customization/app-setup"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/app-setup",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              App Setup
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {isAllow?.includes(218) ? (
                <Accordion.Item
                  eventKey="61"
                  className=""
                  onClick={() => handleClick("41")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon icon="fa-solid fa-font-awesome" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      WebSite Banner
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul className="accordion_list list-unstyled fw-normal pb-1 small">
                      {isAllow?.includes(218) ? (
                        <Link
                          to="/settings/customization/banner"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/customization/banner",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Banner
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************  Customization End ************************************************************* */}
              {/* ************************************************************  Location ************************************************************* */}
              {/* {isAllow?.includes(21) ||
              isAllow?.includes(17) ||
              isAllow?.includes(13) ||
              isAllow?.includes(25) ||
              isAllow?.includes(9) ? (
                <Accordion.Item
                  eventKey="8"
                  className=""
                  onClick={() => handleClick("8")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon
                        icon="fa-solid fa-map-location-dot"

                        // onClick={() => setIsOpen(!isOpen)}
                      />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Location
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(25) ? (
                        <Link
                          to="/settings/location/country-code"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/location/country-code",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Country Code
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(9) ? (
                        <Link
                          to="/settings/location/country"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/location/country",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Country
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(13) ? (
                        <Link
                          to="/settings/location/state"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/location/state",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              State
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(17) ? (
                        <Link
                          to="/settings/location/city"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/settings/location/city")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              City
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(21) ? (
                        <Link
                          to="/settings/location/pincode"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/settings/location/pincode",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Pincode
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )} */}
              {isAllow?.includes(87) ||
              isAllow?.includes(83) ||
              isAllow?.includes(77) ||
              isAllow?.includes(69) ||
              isAllow?.includes(65) ? (
                <Accordion.Item
                  eventKey="17"
                  className=""
                  onClick={() => handleClick("17")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon icon="fa-solid fa-question" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Why Choose Icab Tours
                    </p>
                  </Accordion.Header>

                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul className="accordion_list list-unstyled fw-normal pb-1 small">
                      {isAllow?.includes(65) ? (
                        <Link
                          to="/about-us/why-choose"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/about-us/why-choose")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Why Choose
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(69) ? (
                        <Link
                          to="/about-us/our-mission"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/about-us/our-mission")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Our Vission Mission
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {isAllow?.includes(77) ? (
                        <Link
                          to="/about-us/social-media"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/about-us/social-media")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Social Media
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {/* {isAllow?.includes(83) ? (
                        <Link
                          to="/about-us/about-us-main"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/about-us/about-us-main")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              About Us
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                      {/* {isAllow?.includes(87) ? (
                        <Link
                          to="/about-us/our-team"
                          className=" text-decoration-none  ">
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/about-us/our-team")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Our Team
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )} */}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************   About Us End ************************************************************* */}
              {/* ************************************************************   Content Start ************************************************************* */}
              {isAllow?.includes(227) ||
              isAllow?.includes(186) ||
              isAllow?.includes(222) ||
              isAllow?.includes(95) ||
              isAllow?.includes(91) ? (
                <Accordion.Item
                  eventKey="19"
                  className=""
                  onClick={() => handleClick("19")}>
                  <Accordion.Header>
                    <div
                      className="Accordion_Header_icon-holder
">
                      <FontAwesomeIcon icon="fa-solid fa-feather" />
                    </div>
                    <p
                      className="sidebar_txt"
                      style={{ display: isSidebarOpen ? "block" : "none" }}>
                      Policy Content
                    </p>
                  </Accordion.Header>
                  <Accordion.Body
                    className="p-0"
                    style={{
                      display: isOpen ? "block" : "none",
                    }}>
                    <ul
                      className="accordion_list list-unstyled fw-normal pb-1 small"
                      // style={{
                      //   display: isSidebarOpen ? "block" : "none",
                      // }}
                    >
                      {isAllow?.includes(91) ? (
                        <Link
                          to="/content/privacy"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/content/privacy")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Privacy Policy
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(95) ? (
                        <Link
                          to="/content/terms"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/content/terms")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Terms & Conditions
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(222) ? (
                        <Link
                          to="/content/disclaimer"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes("/content/disclaimer")
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Disclaimer
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(186) ? (
                        <Link
                          to="/content/cancellation-policy"
                          className=" text-decoration-none  "
                          // className="text-decoration-none rounded "
                        >
                          <li
                            className={
                              isOpen
                                ? headerText.includes(
                                    "/content/cancellation-policy",
                                  )
                                  ? "active block"
                                  : "none"
                                : "none"
                            }>
                            <p
                              className="insideDropdown_list"
                              style={{ display: isOpen ? "block" : "none" }}>
                              Cancellation Policy
                            </p>
                          </li>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ) : (
                <></>
              )}
              {/* ************************************************************   Content Start ************************************************************* */}
            </Accordion>
          </ul>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
